import React from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import { getAppointmentOperationalStatusMeta } from 'constants/appointmentStatus.constant'
import { getAppointmentStatusActorLabel } from './appointmentStatusDialog.utils'

const formatHistoryDate = (value) => {
    const date = dayjs(value)
    return date.isValid()
        ? date.locale('fr').format('D MMM YYYY [à] HH:mm')
        : 'Date non disponible'
}

const AppointmentStatusHistory = ({ history, preferences }) => (
    <aside className="min-w-0 border-t border-gray-100 pt-5 dark:border-gray-600 md:border-l md:border-t-0 md:pl-5 md:pt-0">
        <h6 className="text-sm font-semibold text-gray-800 dark:text-gray-100">
            Historique
        </h6>
        {history.length > 0 ? (
            <div className="mt-3 max-h-72 divide-y divide-gray-100 overflow-y-auto pr-1 dark:divide-gray-600">
                {history.map((entry) => {
                    const meta =
                        entry.status === 'confirme'
                            ? {
                                  label: 'Confirmé',
                                  color: preferences.confirmedColor,
                              }
                            : getAppointmentOperationalStatusMeta(
                                  entry.status,
                                  preferences
                              )
                    const actor = getAppointmentStatusActorLabel(
                        entry.changedBy
                    )

                    return (
                        <div
                            key={
                                entry._id ||
                                `${entry.changedAt || 'legacy'}-${entry.status}`
                            }
                            className="py-3 first:pt-0"
                        >
                            <div className="flex items-center gap-2">
                                <span
                                    className="h-2 w-2 shrink-0 rounded-full"
                                    style={{
                                        backgroundColor: meta?.color,
                                    }}
                                />
                                <span className="text-xs font-semibold text-gray-700 dark:text-gray-100">
                                    {meta?.label || entry.status}
                                </span>
                            </div>
                            <p className="mt-1 text-xs text-gray-400">
                                {formatHistoryDate(entry.changedAt)}
                                {actor ? ` · ${actor}` : ''}
                            </p>
                            {entry.note ? (
                                <p className="mt-1 break-words text-xs leading-relaxed text-gray-600 dark:text-gray-300">
                                    {entry.note}
                                </p>
                            ) : null}
                        </div>
                    )
                })}
            </div>
        ) : (
            <p className="mt-3 rounded-lg border border-dashed border-gray-200 px-3 py-4 text-xs leading-relaxed text-gray-400 dark:border-gray-600 dark:text-gray-300">
                Aucun changement de statut enregistré pour ce rendez-vous.
            </p>
        )}
    </aside>
)

export default AppointmentStatusHistory
